export const BANK_STATEMENT_MIN_FILES = 3;
export const DEFAULT_PROOF_OF_INCOME_MIN_FILES = 1;

export function getProofOfIncomeRequiredFileCount(
  documentType: string | undefined,
) {
  return documentType === "bank_statement"
    ? BANK_STATEMENT_MIN_FILES
    : DEFAULT_PROOF_OF_INCOME_MIN_FILES;
}

export function getExistingProofOfIncomeFilesCount({
  existingFilesCount,
  savedDocumentType,
  selectedDocumentType,
}: {
  existingFilesCount: number;
  savedDocumentType: string | undefined;
  selectedDocumentType: string | undefined;
}) {
  if (!selectedDocumentType) return 0;
  if (!savedDocumentType || savedDocumentType === selectedDocumentType) {
    return existingFilesCount;
  }
  return 0;
}

export function getRequiredNewProofOfIncomeSlots({
  documentType,
  existingFilesCount,
}: {
  existingFilesCount: number;
  documentType: string | undefined;
}) {
  return Math.max(
    getProofOfIncomeRequiredFileCount(documentType) - existingFilesCount,
    0,
  );
}
